import { AppBar, Avatar, IconButton, Toolbar } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
// import ford_logo from "./images/ford_logo.png";
import Logout from "@mui/icons-material/Logout";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../store/customHooks";
import HeaderLogo from './images/Fordlogo1.png';


const useStyles = makeStyles((theme: any) => ({
  root: {
    display: "flex",
    // marginBottom: "2%",
  },
  toolbar: {
    paddingRight: "-19px",
    minHeight: "50px !important",
    backgroundColor: "#03025d",
    paddingLeft: '0 !important',
    display: "flex",
    justifyContent: "space-between"
  },

  rectangle: {
    width: 72,
    height: 38,
    cursor: "pointer",
    marginLeft: "10px"
  },
  time: {
    color: 'white',
    marginLeft: '30px',
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0
    },
    [theme.breakpoints.down("md")]: {
      marginLeft: 0
    },
  }
}));

export default function Header(props: any) {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const date = new Date().toJSON()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const authData = JSON.parse(localStorage.getItem("AUTH_DATA") || "{}");


  const logout = () => {
    navigate("/login");
    dispatch({ type: "OnLoginAsync", payload: {} });
    localStorage.removeItem("AUTH_DATA");
  };


  const handleClose = () => {
    setAnchorEl(null);
  };

  const goToHome = () => {
    let authDetails = localStorage.getItem("AUTH_DATA")
    if (window.location.pathname === '/appointmentBooking' || window.location.pathname === "unauthrizedAppointmentBooking") {
      navigate("/appointmentBooking")
    } else {
      if (authDetails) {
        navigate("/dashboard");
      } else { navigate("/login"); }
    }
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  return (
    <>
      <AppBar position={props.position} className={classes.root} color="inherit">
        <Toolbar className={classes.toolbar}>

          {(authData?.referenceData?.authorizedBranches) ?
            <> <img
              className={classes.rectangle}
              alt="Logo"
              src={HeaderLogo}
              onClick={goToHome}
            />
              <div>
                <span style={{ color: "white", fontSize: "26px" }}>Welcome To {authData?.referenceData?.authorizedBranches?.find((f: any) => f.BranchId == authData?.referenceData?.defaultBranch)?.BranchDescription}</span>
              </div></> :
            <> <img
              className={classes.rectangle}
              alt="Logo"
              src={HeaderLogo}
            />
              <span style={{ color: "white", fontSize: "26px",textAlign:"center" }}>Welcome To Ford</span>
            </>

          }

          {authData?.referenceData?.authorizedCompanies && (
            <div >
              <IconButton
                onClick={handleClick}
                size="small"
                // sx={{ ml: 105}}
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <Avatar sx={{ width: 35, height: 35 }} />
              </IconButton>

              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 20,
                      height: 20,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 3,
                      height: 5,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem onClick={logout}>
                  <ListItemIcon>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </Menu>
            </div>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
}
